import {Children, Fragment, isValidElement, ReactNode} from 'react'
import {isArray, pipe} from 'remeda'
import {match} from 'ts-pattern'

const propsAsObject = <T extends {}>(n: {props: unknown}): T => (n.props ?? {}) as T

export const unwrapFragment = (n: ReactNode): ReactNode[] =>
  n == null
    ? []
    : Children.toArray(n).flatMap(n =>
        match(n)
          .with({type: Fragment}, f =>
            pipe(propsAsObject<{children?: ReactNode}>(f), ({children}) => unwrapFragment(children))
          )
          .otherwise(n => n)
      )

export const getFlattenedChildren = (children: ReactNode) =>
  Children.toArray(unwrapFragment(children))
    .filter(isValidElement)
    .map(child => (isArray(child) ? child : [child]))
    .map(unwrapFragment)
    .flat()
    .filter(isValidElement)
